export default __webpack_public_path__ + "static/media/be-involved.1643589c.png";